import React from 'react';
import { Routes, Route } from 'react-router-dom';
// Import Shared Components
import { ErrorBoundary } from 'shared-components';
// Import Layouts
import Base from '../layouts/Base';
import Body from '../layouts/Body';
import Header from '../layouts/Header';
import Footer from '../layouts/Footer';
import NotFound from '../layouts/NotFound';
import Shell from '../layouts/Shell';
// Import Route Components
import Verify from './Verify';
import TC from './TermsAndConditions';
import Esign from './Esign';
import Activated from './Activated';
import Recover from './Recover';
import Recovered from './Recovered';
import CamsRedirect from './CamsRedirect';
import { errorLogger } from '../utils/errors';

const Root = props => (
  <Shell>
    <Base>
      <Header {...props} />
      <Body>
        <ErrorBoundary errorLogger={errorLogger}>
          <Routes>
            <Route path="/CardHolder/VerifyData/:langAndToken" element={<CamsRedirect {...props} />} />
            <Route path="/activate/:emailLink" element={<Verify />} />
            <Route path="/recover/:emailLink" element={<Recover />} />
            <Route path="/terms" element={<TC />} />
            <Route path="/esign" element={<Esign />} />
            <Route path="/activated" element={<Activated />} />
            <Route path="/recovered" element={<Recovered />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </ErrorBoundary>
      </Body>
      <Footer />
    </Base>
  </Shell>
);

export default Root;
